import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=2bc247d2&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=2bc247d2&prod&scoped=true&lang=scss&"
import style1 from "./Group.vue?vue&type=style&index=1&id=2bc247d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc247d2",
  null
  
)

export default component.exports